import {
  FilterContainer,
  RolesAndFacilitiesContainer,
  AddUserButtonContainer,
  AddUserButton,
  AddIcon,
  MainSelectContainer,
} from "./User.style";

import addIcon from "../../../assets/images/add_icon.svg";

import { GlobalFilter } from "./GlobalFilter";
import { useStoreWrapper } from "../../../store/store";
import { useNavigate } from "react-router-dom";
import { FilterDropdown } from "../../../components/StyledTable/filterFunctions";
import styled from "styled-components";
import ActionBtnU from "./components/ActionBtnU";
import { ClearFilterContainer } from "./FilterComponentGeneral";
import { LuFilterX } from "react-icons/lu";
import { cn } from "../../../utils/helpers/cn";
import { toastService } from "../../../utils/helpers/toastService";
import { blockedAddUserMessage, hasEmail } from "./actingUserEmail";

interface Props {
  filter: string;
  setFilter: (filter: string) => void;
  headerGroups: any;
  facilities?: any;
  roles?: any;
  facilitiesLoading?: boolean;
  rolesLoading?: boolean;
  resetUser?: any;
  rolesData?: [];
  facilitiesData?: [];
  where?: any;
  setRoleFilter: (role: string) => void;
  roleFilter: string;
  facilityFilter: string;
  setFacilityFilter: (role: string) => void;
  showAddNewUserBtn?: boolean;
  searchValue?: string;
  setSearchValue?: any;
  handleClearFilter?: any;
  searchable?: boolean;
  clearReactSelect?: boolean;
  searchPlaceholder?: string;
}
// TODO:don't forget to consider filtering in the server side
interface IFilterProps {
  marginRight?: string;
}
const FilterSelContainer = styled.div<IFilterProps>`
  @media screen and (min-width: 961px) {
    width: 250px;
    margin-right: 10px;
  }
  @media screen and (min-width: 436px) and (max-width: 960px) {
    width: 250px;
    margin-right: 10px;
  }

  @media screen and (min-width: 375px) and (max-width: 435px) {
    margin: 10px 0px;
    margin-right: ${(props) => props.marginRight ?? "0px"};
  }
  @media screen and (min-width: 360px) and (max-width: 374px) {
    margin: 10px 0px;
    margin-right: ${(props) => props.marginRight ?? "0px"};
  }
  @media screen and (width: 320px) {
    margin: 10px 0px;
  }
`;
const FilterComponent = ({
  filter,
  setFilter,
  rolesData,
  roleFilter,
  setRoleFilter,
  facilitiesData,
  facilityFilter,
  setFacilityFilter,
  showAddNewUserBtn,
  searchValue,
  setSearchValue,
  handleClearFilter,
  where,
  searchable,
  clearReactSelect,
  searchPlaceholder,
}: Props) => {
  const navigate = useNavigate();

  // -------- intialize custom hooks --------
  const resetUser = useStoreWrapper((state) => state.resetUser);
  // Null when the signed-in user may add users; otherwise the reason they can't.
  const blockedMessage = useStoreWrapper((state) =>
    hasEmail(state.user) ? null : blockedAddUserMessage(state.user)
  );

  return (
    <FilterContainer>
      {/* searchBar  */}
      <GlobalFilter
        containerClassName="border border-solid border-gray-300 lg:w-80 xl:w-60 xl:max-w-52"
        searchBarClassName="lg:w-80 xl:w-60 xl:max-w-52"
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        filter={filter}
        setFilter={setFilter}
        data-testid="search-bar"
        placeholder={searchPlaceholder}
      />
      {/* addMargin role="role" */}
      <RolesAndFacilitiesContainer>
        <MainSelectContainer>
          <FilterSelContainer marginRight="10px">
            <FilterDropdown
              options={rolesData}
              value={roleFilter}
              onChange={(e: any) => {
                if (searchable) setRoleFilter(e.value);
                else setRoleFilter(e.target.value);
              }}
              placeholder="All Roles"
              where={where}
              searchable={searchable}
              name="roles"
              handleClearFilter={handleClearFilter}
              clearReactSelect={clearReactSelect}
            />
          </FilterSelContainer>
          <FilterSelContainer>
            <FilterDropdown
              options={facilitiesData}
              value={facilityFilter}
              onChange={(e: any) => {
                if (searchable) setFacilityFilter(e.value);
                else setFacilityFilter(e.target.value);
              }}
              placeholder="All Facilities"
              where={where}
              searchable={searchable}
              name="facilities"
              handleClearFilter={handleClearFilter}
              clearReactSelect={clearReactSelect}
            />
          </FilterSelContainer>
        </MainSelectContainer>
        {/* clear filters btn */}
        <ClearFilterContainer>
          <ActionBtnU
            className="flex w-full items-center justify-center bg-purple-300"
            color="white"
            onClick={() => handleClearFilter()}
          >
            <span className="inline xl:hidden">Clear Filters</span>
            <LuFilterX className="hidden xl:inline" size={20} />
          </ActionBtnU>
        </ClearFilterContainer>
      </RolesAndFacilitiesContainer>
      {/* add new user */}
      {showAddNewUserBtn && (
        <AddUserButtonContainer>
          {/* aria-disabled, not disabled, so a click can still explain why */}
          <AddUserButton
            className={cn(
              "cursor-pointer md:max-w-32 lg:max-w-28",
              // Tailwind is configured important, so these beat the styled-component hover/cursor.
              blockedMessage &&
                "cursor-not-allowed opacity-50 hover:border-0 hover:bg-purple-light"
            )}
            aria-disabled={!!blockedMessage}
            aria-describedby={
              blockedMessage ? "add-user-blocked-reason" : undefined
            }
            title={blockedMessage ?? undefined}
            onClick={() => {
              if (blockedMessage) {
                toastService.error(blockedMessage, {
                  autoClose: 4000,
                  toastId: "add-user-no-email",
                });
                return;
              }

              navigate("/user/users/create");
              resetUser();
            }}
          >
            <AddIcon src={addIcon} alt="plus icon" />
            New User
          </AddUserButton>
          {blockedMessage && (
            <span id="add-user-blocked-reason" className="sr-only">
              {blockedMessage}
            </span>
          )}
        </AddUserButtonContainer>
      )}
    </FilterContainer>
  );
};

export default FilterComponent;
